export default __webpack_public_path__ + "static/media/Objective.0481bbf4.woff";